export default "<div #map class=\"map\">\n  <div #popup class=\"popup\"></div>\n</div>";